import { Model } from '@opaquejs/opaque'
import { makeReactive } from '@opaquejs/vue'

export default class Wall extends makeReactive(Model) {
    
    static get schema() {
        return {
            id: null,
            name: null,
            length: 1,
            breaks: 0,
            lighted: this.LIGHTING.NONE,
            central_power_supply: null,
            useplug: null,
            color: this.LIGHT_COLOR.WARMWHITE,
            bar_color: this.BAR_COLOR.WHITE,
            dimmable: null,
            smart: null,
            activated: true,
            funkschalter: null,
            existing_smarthome: null
        }
    }

    static group(walls) {
        return walls.reduce((groups, wall) => {
            let pushed = false
            for(const group of groups) {
                if(wall.hasSameConfigurationAs(group[0])) {
                    group.push(wall)
                    pushed = true
                }
            }
            if(!pushed) {
                groups.push([ wall ])
            }
            return groups
        }, [])
    }

    static groupBy(walls, getkey) {
        return walls.reduce((groups, wall) => {
            const key = getkey(wall)
            if(!groups[key]) {
                groups[key] = []
            }
            groups[key].push(wall)
            return groups
        }, {})
    }

    static wallsToLocaleString(walls, vue) {
        if(walls.length > 1) {
            return `${vue.$tc('commons.wall', 2)} ` + walls.map(otherwall => otherwall.name).slice(0, -1).join(', ') + ` ${vue.$t('commons.and')} ` + walls[walls.length -1].name
        }
        return `${vue.$tc('commons.wall', 1)} ` + walls[0].name
    }

    hasNormalLighting() {
        return [Wall.LIGHTING.UP, Wall.LIGHTING.DOWN].includes(this.lighted)
    }

    hasNoLighting() {
        return [Wall.LIGHTING.NONE].includes(this.lighted)
    }

    get power_supply() {
        if(this.central_power_supply == 'commons.yes') {
            return '24V'
        } else if(this.useplug == 'commons.yes') {
            return 'plug'
        } else {
            return null
        }
    }

    hasCentralPowerSupply() {
        return this.power_supply == '24V'
    }

    hasNoCentralPowerSupply() {
        return this.central_power_supply === 'commons.no'
    }

    hasPowerSupply() {
        return this.power_supply != null
    }

    isStatic() {
        return this.dimmable === 'commons.no'
    }

    hasSmarthomeIntegration() {
        return this.smart === 'commons.yes'
    }

    hasRemoteControl() {
        return this.funkschalter === 'commons.yes'
    }

    isDefault() {
        return JSON.stringify(this.comparableObject()) == JSON.stringify({ ...new Wall().comparableObject() })
    }

    comparableObject() {
        return { ...this.getAttributes(), name: null, length: null, breaks: null }
    }

    hasSameConfigurationAs(other) {
        return JSON.stringify(this.comparableObject()) == JSON.stringify(other.comparableObject()) && other != this && !other.isDefault()
    }

    copyFrom(other) {
        this.setAttributes({ ...other.getAttributes(), name: this.name, length: this.length, breaks: this.breaks })
    }
}

Wall.names = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')

Wall.LIGHT_COLOR = {
    RGB: 'wall.light-color.options.rgb',
    WARMWHITE: 'wall.light-color.options.warmwhite',
    WHITE: 'wall.light-color.options.white',
}

Wall.LIGHTING = {
    UP: 'wall.lighting.options.up',
    DOWN: 'wall.lighting.options.down',
    NONE: 'wall.lighting.options.none',
}

Wall.BAR_COLOR = {
    WHITE: 'wall.bar-color.options.white',
    CHAMPAGNER: 'wall.bar-color.options.champagner',
    //SILVER: 'wall.bar-color.options.silver',
    ALUMINIUM: 'wall.bar-color.options.aluminium',
    ANTHRAZIT: 'wall.bar-color.options.anthrazit',
}